module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "back-to-top-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "vue-back-to-top",
    style: (("bottom:" + (this.bottom) + ";right:" + (this.right) + ";")),
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "default"
  }, [_c('span', [_vm._v("\n          " + _vm._s(_vm.text) + "\n        ")])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e44608da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-backtotop/src/BackToTop.vue
// module id = 13
// module chunks = 0